var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18707 1.68707C0.5 3.37413 0.5 6.08942 0.5 11.52V12.48C0.5 17.9106 0.5 20.6259 2.18707 22.3129C3.87413 24 6.58942 24 12.02 24H12.98C18.4106 24 21.1259 24 22.8129 22.3129C24.5 20.6259 24.5 17.9106 24.5 12.48V11.52C24.5 6.08942 24.5 3.37413 22.8129 1.68707C21.1259 0 18.4106 0 12.98 0H12.02C6.58942 0 3.87413 0 2.18707 1.68707ZM4.5 7.35C4.62848 13.593 7.90768 17.35 13.3126 17.35H13.6261V13.7784C15.5946 13.9782 17.0626 15.4499 17.6619 17.35H20.5C19.7301 14.5075 17.7338 12.936 16.4931 12.3356C17.7328 11.593 19.4875 9.79284 19.9007 7.35H17.3186C16.7769 9.33655 15.1651 11.1367 13.6252 11.3077V7.35H11.0018V14.2789C9.40537 13.8793 7.32279 11.936 7.23746 7.35H4.5Z",
    fill: "#2D81E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkIcon);
export default __webpack_public_path__ + "static/media/vk_icon.b195c6ac9145b6213b0967b4ca1e89b1.svg";
export { ForwardRef as ReactComponent };